import { Box, Pressable, useMediaQuery } from "native-base";
import Svg from "react-native-svg";
import { deleteIconSVG } from "../../utils/svg";
import { hasPermission } from "../../utils/permission";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import ImageViewer from "../../components/imageViewer";

const ViewUploadImageCards = ({
  url = "",
  ind,
  onDeleteImage,
  width = "165px",
  height = "167px",
  svg = deleteIconSVG,
  svgwh = "24",
  p = "1",
  permission = true,
  type = "detail",
  scrollToTop = () => {},
  resizeMode=false,
  onVideoClick = null
}) => {
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  return (
    <Box
      // position="relative"
      // width={width}
      // height={height}
      mb={3.5}
      mr={3.5}
      // onPress={scrollToTop()}
      // style={{
      //   background:
      //     "linear-gradient(270deg, rgba(255,255,255) 0%, rgba(255,255,255) 100%)",
      // }}
    >
      <ImageViewer
        path
        images={[{ file_name: url }]}
        imagesChange={false}
        toolbar={false}
        notification={resizeMode}
        onVideoClick={onVideoClick}
        showIndividualCheckboxes={false}
      />
      {((hasPermission("REVIEW") && type === "detail") ||
        (!hasPermission("REVIEW") && permission)) && (
        <>
          {/* <Box
            position="absolute"
            top={0}
            right={0}
            bottom={0}
            left={0}
            bg="rgba(0,0,0,0.3)"
          /> */}
          <Pressable
            onPress={() => {
              onDeleteImage(ind);
            }}
            zIndex="99"
            position="absolute"
            top={1}
            right={1}
            p={p}
            style={{
              width: "50px",
              height: "50px",
              marginTop: MobileWindow ? "3px" : 0,
              backgroundImage: `linear-gradient(to bottom left, #00000033 25%, transparent 100%)`,
            }}
          >
            <Svg width={svgwh} height={svgwh} viewBox={`0 0 ${svgwh} ${svgwh}`}>
              {svg}
            </Svg>
          </Pressable>
        </>
      )}
    </Box>
  );
};

export default ViewUploadImageCards;
